import { SEARCH_VERTICALS } from 'constants/search'
import React, { useCallback, useEffect } from 'react'
import { addGTMEvent } from 'api/googleTagManager'
import { searchFormDisplay } from 'analytics/eventDefinitions'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import useGlobalSearchVerticalTabsV2 from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabsV2'
import GlobalMobileSearchV2 from 'components/SearchV2/Components/Mobile/GlobalMobileSearchV2'

/**
 * Wrapper component that will render the mobile search v2 elements into the DOM
 * Note: this should be replaced with a `showModal` implementation
 */

function NavBarSearchDrawer() {
  const tabs = useGlobalSearchVerticalTabsV2()
  const { toggleSearchVertical, openedSearchVertical } = useGlobalSearchURLHashVertical()

  const selectedTab = openedSearchVertical ? tabs.get(openedSearchVertical) : undefined

  const onSelectTab = useCallback((key: SEARCH_VERTICALS) => {
    toggleSearchVertical(key)
  }, [toggleSearchVertical])

  useEffect(() => {
    addGTMEvent(searchFormDisplay())
  }, [])

  const closeSearch = useCallback(() => { toggleSearchVertical('none') }, [toggleSearchVertical])

  return <GlobalMobileSearchV2
    isOpen={!!openedSearchVertical}
    tabs={tabs}
    closeSearch={closeSearch}
    selectedTab={selectedTab}
    onTabSelect={onSelectTab}
    onSearch={selectedTab?.onSearch}
  />
}

export default NavBarSearchDrawer
